import React from 'react';
import '../../generic/index.css';
import {
  LessonInstructorDisplay,
  lessonInstructorDisplaySwatchClass
} from '../../../utils/lessonInstructorUtils';
import { LessonAssignment } from '../../../types/lesson.type';

interface InstructorsCellProps {
  instructors: LessonInstructorDisplay[];
  lessonAssignments?: LessonAssignment[];
}

export const InstructorsCell: React.FC<InstructorsCellProps> = ({
  instructors,
  lessonAssignments = []
}) => {
  return (
    <div className="instructors-cell lesson-instructor-display-stack">
      {instructors.map((instructor) => (
        <div
          key={`${instructor.id}-${instructor.role}`}
          className="lesson-instructor-display-row"
        >
          <div
            className={`swatch ${lessonInstructorDisplaySwatchClass(instructor, lessonAssignments)}`}
          >
            {instructor.name}
          </div>
        </div>
      ))}
    </div>
  );
};
